import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiLegalDocument } from './api-legal-documents';

export interface LegalDocumentsProvider {
  readonly data$: Observable<ApiLegalDocument | null>;

  loadData(): void;
}

export const LEGAL_DOCUMENT_FACADE_PROVIDER_TOKEN =
  new InjectionToken<any>('LEGAL_DOCUMENT_FACADE_PROVIDER_TOKEN');
